// src/sentry.client.ts
import { useEffect } from 'preact/hooks';
import * as Sentry from '@sentry/browser';
import { extraErrorDataIntegration } from '@sentry/browser';

export default function SentryClient() {
  useEffect(() => {
    Sentry.init({
      dsn: import.meta.env.PUBLIC_SENTRY_DSN,
      enabled: true,
      environment: import.meta.env.MODE,
      integrations: [extraErrorDataIntegration()],
      beforeSend(event, hint) {
        const error = hint?.originalException;

        if (
          error instanceof TypeError &&
          error.message?.includes("Cannot read properties of null (reading 'createElement')")
        ) {
          return null;
        }

        if (
          error instanceof TypeError &&
          error.message?.includes("null is not an object (evaluating 'history.state.index')")
        ) {
          return null;
        }

        return event;
      },
    });
  }, []);

  return null;
}
